export default "__VITE_ASSET__36a6a5c6__"